import { styled } from "@mui/material";
import { chipName } from "../classes.js";
const doNotForward = ["sx", "as", "theme", "ownerState", "shiftX"];
const RightAdornmentPlacer = styled("div", {
  name: chipName,
  slot: "RightAdornmentPlacer",
  overridesResolver: (_props, styles) => [styles.rightAdornmentPlacer],
  shouldForwardProp: (prop) => !doNotForward.includes(prop)
})(({ theme, ownerState, shiftX }) => {
  const marginRight = getMarginRight(ownerState?.size ?? "medium", shiftX ?? false);
  return {
    marginRight: theme.spacing(marginRight)
  };
});
function getMarginRight(size, shiftX) {
  if (!shiftX) return 0;
  switch (size) {
    case "small":
      return -0.5;
    case "medium":
    default:
      return -0.75;
  }
}
export {
  RightAdornmentPlacer
};
//# sourceMappingURL=RightAdornmentPlacer.js.map
